import React, { useEffect } from 'react';
import { Collapse } from 'react-collapse';
import styled from 'styled-components';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import useToggle from '../hooks/useToggle';

const FaqDropdownStyles = styled.div`
  background: var(--lightbeige);
  text-align: start;

  .question {
    display: flex;
    justify-content: space-between;

    h2 {
      font-weight: bold;
      color: black;
    }
  }

  padding: 20px 20px;

  button {
    display: inline-block;
    padding: 10px 10px;
    color: var(--green);
    border: var(--green) 2px solid;
    background: var(--lightbeige);
    box-shadow: 0 0 0;
    border-radius: 50%;
    font-size: 27px;
    line-height: 0;
  }

  .button-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
`;

export default function Faq({ content, loc }) {
  const [isOn, toggledIsOn] = useToggle(false);

  useEffect(() => {
    if (loc === 'faq') {
      toggledIsOn(true);
    }
  }, []);

  return (
    <div>
      <FaqDropdownStyles>
        <div className="question">
          <h3>{content.question}</h3>
          <div className="button-wrapper">
            <button onClick={toggledIsOn}>
              {isOn ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
            </button>
          </div>
        </div>
        <Collapse isOpened={isOn}>
          <div className="answer">
            <p>{content.answer}</p>
          </div>
        </Collapse>
        <hr />
      </FaqDropdownStyles>
    </div>
  );
}
